import { forwardRef, HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export type TypographyMaskProps = HTMLAttributes<HTMLSpanElement> & {
  children: JSX.Element
}

const TypographyMask = forwardRef<HTMLSpanElement, TypographyMaskProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <span
        ref={ref}
        data-label={children?.props?.children}
        className={cn(
          [
            'relative inline-flex overflow-hidden',
            'after:text-label after:content-[attr(data-label)]',
            'after:absolute after:left-0 after:top-0 after:h-full after:w-full after:translate-y-full',
            'after:transition-transform after:duration-500 after:ease-out-cubic',
            '[&>span]:grow [&>span]:transition-transform [&>span]:duration-300 [&>span]:ease-out-cubic',
            '[&>span]:group-hover:-translate-y-full',
            'group-hover:after:translate-y-0'
          ],
          className
        )}
        {...props}
      >
        {children}
      </span>
    )
  }
)

export default TypographyMask
